module.exports = __webpack_public_path__ + "static/media/home_icon.0d92c28e.svg";